import { render, staticRenderFns } from "./PerformDashSurveyPage.vue?vue&type=template&id=0259d820&scoped=true&"
import script from "./PerformDashSurveyPage.vue?vue&type=script&setup=true&lang=ts&"
export * from "./PerformDashSurveyPage.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./PerformDashSurveyPage.vue?vue&type=style&index=0&id=0259d820&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0259d820",
  null
  
)

export default component.exports